import React from 'react'
import Toast from './Toast';
import { useToastsContext } from './Provider';

const Toasts = () => {
    const {toasts} = useToastsContext();

    return <div
        aria-live="assertive"
        className="pointer-events-none fixed inset-0 flex items-end px-4 py-6 md:mt-8 sm:items-start sm:p-6 z-50"
      >
        <div className="flex w-full flex-col items-center space-y-4 sm:items-end">
            {toasts.map((toast, index) => <Toast key={index} toast={toast} />)}
        </div>
    </div>
}

export default Toasts;
